<template>
  <p class="m-0 font-medium text-gray-900 ds-text-4xl">{{ isBaseball ? baseballPositions : positions.join(', ') }}</p>
</template>

<script>
export default {
    props: {
        positions: {
            type: Array
        },
        sport: {
            type: String
        }
    },
    data() {
        return {
            // Object of position names. 
            baseballPositionsLongform: {
            "OF": "Outfielder",
            "INF": "Infielder",
            "LF": "Left Field",
            "RF": "Right Field",
            "CF": "Center Field",
            "P": "Pitcher",
            "C": "Catcher",
            "1B": "First Base",
            "2B": "Second Base",
            "3B": "Third Base",
            "SS": "Shortstop",
            "UTL": "Utility"
            }
        }
    },
    computed: {
        isBaseball() {
            // Check if the sport is either baseball or softball.
            return /^(base|soft)ball/.test(this.sport)
        },
        // Presentational transform of the baseball positions
        baseballPositions() {
            const vm = this;
            if (!this.positions) {
                return null
            }
            return this.positions.map(position => vm.baseballPositionsLongform[position]).join(', ') 
        }
    }
}
</script>